module.exports = __webpack_public_path__ + "img/smile.1d393dba.svg";